<template>
  <div class="launch">
    <!-- <img class="logo" alt="logo" src="../../assets/svgs/logo.svg" /> -->
    <svg style="width: 40%; fill: white"><use xlink:href="#icon-logo"/></svg>
    <span style="color: #aaa; margin-top: 20px;">
      正在載入系統
      <i class="el-icon-loading"></i>
    </span>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    goMain () {
      let defaultRouter = this.$store.state.admin.ID === 1 ? 'systemLog-list' : 'message-list'
      if (this.$store.state.admin.AdminLevel == 100) defaultRouter = 'order-list'
      if (this.$store.state.admin.AdminLevel == 10) defaultRouter = 'teamBuying-statistics'
      this.$router.push({ name: defaultRouter })
    },
    goLogin () {
      this.$router.push({ name: 'login' })
    }
  },
  created () {
    // 如果已登入
    let handleError = err => {
      console.error(err)
      this.$alert(`請聯絡管理員。\n${err}`, '錯誤', {
        confirmButtonText: '確定',
        callback: action => { this.goLogin() }
      })
    }
    let isLogined = this.$services.auth.isLogined()
    if (isLogined) {
      this.$services
        .fetchMe(this)
        .then(() => {
          if (this.$store.state.admin.AdminLevel > 100) return this.$services.fetchDatas(this)
          return true
        })
        .then(this.goMain)
        .catch(handleError)
    } else {
      this.goLogin()
    }
  }
}
</script>

<style scoped>
.launch {
  width: 100%;
  height: 100%;
  background-color: rgb(112, 112, 112);
  position: fixed;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logo {
  width: 200px;
  margin-top: -50px;
  margin-bottom: 12px;
}
</style>
